import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function About() {
  // Footer
  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain";
  }, []);

  // Navs and Footer
  useEffect(() => {
    const nav = document.querySelector(".navigation-large");
    nav.className =
      "navigation-large d-none d-md-flex justify-content-between fixed-top section-bg";
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".navigation-small");
    nav.className =
      "navigation-small d-flex justify-content-between d-md-none fixed-top section-bg";
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain section-bg";
  }, []);

  return (
    <>
      <Container className="section-contain">
        <Helmet>
          <body className="section-bg" />
          <title>About - GarageFonts</title>
          <meta property="og:title" content="About - GarageFonts" />
        </Helmet>
        <Row>
          <Col md={12}>
            <h1 className="header">About</h1>
          </Col>
        </Row>
        <Row>
          <Col lg={7}>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link to="/foundry" className="nav-link active">
                  Foundry
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/colophon" className="nav-link">
                  Colophon
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col lg={7} className="mt-4">
            <p>
              GarageFonts is an independent type foundry based in Pittsburgh,
              Pennsylvania. GarageFonts was established in 1993, primarily as a
              vehicle to distribute some of the first typeface designs created
              for Ray Gun magazine. What started as a small library of trend
              setting designs has now grown to a varied collection of original,
              accessible text and display typefaces. We aim to release typefaces
              that are relevant, significant, purposive, and beautiful.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default About;
